import { Dispatch, SetStateAction } from "react"

import "react-quill/dist/quill.snow.css"
import { ModifiedIncident } from ".."
import { RichTextEditor } from "src/components/common/rich-text-editor"
import { Select } from "src/components/common/select"
import { create } from "src/helpers/bem"
import { Dialogs, useDialog } from "src/states/dialogs"
import { TranslationMessages } from "src/translations"

import styles from "./InfoFields.module.scss"

const bem = create(styles, "InfoFields")

type WebshopSalesorderType = 761330005 | 761330007 | 761330008

type InfoFieldsProps = {
  messages: TranslationMessages
  incident: ModifiedIncident
  setIncident: Dispatch<SetStateAction<ModifiedIncident>>
}

export const InfoFields = ({
  messages,
  incident,
  setIncident,
}: InfoFieldsProps) => {
  const { disabled: isReadOnly } = useDialog(
    "incidentDialog",
  ) as Dialogs["incidentDialog"]

  const infoMessage =
    messages.pages.account.overview.profile.incidents.createDialog

  const { description } = incident
  const selectOptions: WebshopSalesorderType[] = [
    761330005, 761330007, 761330008,
  ]

  const handleTypeChange = (value: string | string[] | null) => {
    const orderTypes = (value as []) || []
    setIncident((prev) => ({
      ...prev,
      orderTypes: orderTypes.map((t) => Number(t)),
    }))
  }

  return (
    <div className={bem()}>
      <Select
        disabled={isReadOnly}
        label={infoMessage.infoFields.productType.label}
        multiple={true}
        sizeVariant="medium"
        value={incident.orderTypes || []}
        items={selectOptions.map((option) => ({
          value: `${infoMessage.infoFields.productType.options[option]}`,
          key: option,
          label: infoMessage.infoFields.productType.options[option],
        }))}
        onChange={(e) => handleTypeChange(e.target.value)}
      />

      <div className={bem("description")}>
        <h5 className={bem("description__label")}>
          {infoMessage.infoFields.description.label}
        </h5>
        <RichTextEditor
          placeholder={infoMessage.infoFields.description.placeholder}
          readOnly={isReadOnly}
          value={description ?? ""}
          onChange={(value) =>
            setIncident((prev) => ({ ...prev, description: value }))
          }
        />
      </div>
    </div>
  )
}
